@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

.address {
	
	&__autocomplete-input {
		border-right: 0;
	}

	&__map-toggle {
		border-left: none !important;
		border-top-left-radius: 0 !important;
		border-bottom-left-radius: 0 !important;
		background-color: Colors.$col-white;
	}

	&__address-column {
		&--no-padding {
			padding-left: 0;
		}
	}
}